export default "__VITE_ASSET__CDF0VM0S__"